import { render, staticRenderFns } from "./TypeChecklistItemCategory.vue?vue&type=template&id=c746f8f0&"
import script from "./TypeChecklistItemCategory.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistItemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports